import { render, staticRenderFns } from "./myActivity_selection.vue?vue&type=template&id=c5e1127e&scoped=true"
import script from "./myActivity_selection.vue?vue&type=script&lang=js"
export * from "./myActivity_selection.vue?vue&type=script&lang=js"
import style0 from "./myActivity_selection.vue?vue&type=style&index=0&id=c5e1127e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e1127e",
  null
  
)

export default component.exports